<div
    appTbDrag
    appTbDropContainer
    class="group/board-card hover:shadow-button px-2 bg-neutral1 rounded-lg"
    orientation="vertical"
    [class]="{ 'bg-neutral3': selected(), 'opacity-50': dragged() }"
    [dragData]="getCardDragData()"
    [data]="getCardDragData()"
    [dropDisabled]="disableDrop()"
    (droppedContainer)="onDrop($event)"
    (dragStarted)="onDragStarted()"
    (dragEnded)="onDragEnded()"
>
    <div class="p-2 pr-0 flex justify-between items-start">
        <app-tb-tooltip-component [tooltip]="title()" [showOnlyOnOverflow]="true">
            <span class="body-2 w-[12rem] truncate">{{ title() }}</span>
        </app-tb-tooltip-component>
        <div class="flex items-center gap-2">
            <div
                class="group-hover/board-card:visible visible md:invisible"
                (click)="$event.stopPropagation()"
            >
                <ng-container
                    *ngTemplateOutlet="favorite(); context: { item: item() }"
                ></ng-container>
            </div>
            <app-tb-more-menu
                #menu
                [template]="moreMenu()"
                class="icon-sm"
                [class]="getMenuClasses(menu.menuOpen)"
            ></app-tb-more-menu>

            <div
                (click)="$event.stopPropagation()"
                class="group-hover/board-card:visible visible"
                [class]="selectedItems().length > 0 ? 'visible' : 'md:invisible'"
            >
                <app-tb-checkbox
                    (valueChange)="selectCard.emit($event)"
                    [value]="selected()"
                    size="small"
                ></app-tb-checkbox>
            </div>
        </div>
    </div>
    <div class="px-2">
        <ng-content></ng-content>
    </div>
</div>
